module.exports = __webpack_public_path__ + "static/img/wealth_level_68.163d339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_68.png
// module id = 1YyM
// module chunks = 0